import React from 'react';
import HighlightFeature, {
  CREATE_CHART,
  TOP,
  ACTION_COMPLETE_SUMMARIZE,
} from '@/components/HighlightFeature';

export const VisualizeOnboarding = () => (
  <HighlightFeature
    position={TOP}
    text={
      <span>
        Click the charts to <b>visualize</b> your results
      </span>
    }
    style={{ minWidth: '300px' }}
    requiredActions={[ACTION_COMPLETE_SUMMARIZE]}
    targetAction={CREATE_CHART}
    hideButton
    delay={3500}
    hideWhenModalsOpen
  />
);
